import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysAgo'
})
export class DaysAgoPipe implements PipeTransform {
  transform(value: any): any {
    const currentDate = new Date();
    const compareTime = new Date(value).getTime();
    const timeDiff = currentDate.getTime() - compareTime;

    // Convert the time difference to days. A same-day timestamp later in the day than "now"
    // (or a server clock slightly ahead) gives a small negative ms diff, which floors to -1
    // rather than 0 — clamp so "today" never reads as "-1 days ago".
    const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    return Math.max(0, daysDiff);
  }
}
